import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Warning } from '../../../models/warning';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WarningPopupComponent {
  constructor(
  ) { }

  ngOnInit() { }

  close(response: boolean): void {
  }
}
